import {
  ADDPRODUCTTOCART,
  REMOVEPRODUCTTOCART,
  HANDLECARTITEMQUENTITY,
} from "./actionType";

export const addProductToCart = (product) => {
  return {
    type: ADDPRODUCTTOCART,
    payload: product,
  };
};

export const removeProductToCart = (productId) => {
  return {
    type: REMOVEPRODUCTTOCART,
    payload: productId,
  };
};

export const handleCartItemQuantity = (productId, oparationType) => {
  return {
    type: HANDLECARTITEMQUENTITY,
    payload: {
      id: productId,
      oparationType,
    },
  };
};
